/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as CommunitiesRouteImport } from './routes/communities'
import { Route as ContentRouteImport } from './routes/content'
import { Route as DataOpsRouteImport } from './routes/data-ops'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as MetricsRouteImport } from './routes/metrics'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PhilanthropyRouteImport } from './routes/philanthropy'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LeaguesIndexRouteImport } from './routes/leagues/index'
import { Route as LeaguesLeagueIdRouteImport } from './routes/leagues/$leagueId'
import { Route as SquadsIndexRouteImport } from './routes/squads/index'
import { Route as SquadsSquadIdRouteImport } from './routes/squads/$squadId'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UsersUserIdRouteImport } from './routes/users/$userId'
import { Route as LeaguesLeagueIdIndexRouteImport } from './routes/leagues/$leagueId/index'
import { Route as LeaguesLeagueIdActivityRouteImport } from './routes/leagues/$leagueId/activity'
import { Route as LeaguesLeagueIdDraftRouteImport } from './routes/leagues/$leagueId/draft'
import { Route as LeaguesLeagueIdMembersRouteImport } from './routes/leagues/$leagueId/members'
import { Route as LeaguesLeagueIdPhilanthropyRouteImport } from './routes/leagues/$leagueId/philanthropy'
import { Route as LeaguesLeagueIdPlayoffsRouteImport } from './routes/leagues/$leagueId/playoffs'
import { Route as LeaguesLeagueIdRostersRouteImport } from './routes/leagues/$leagueId/rosters'
import { Route as LeaguesLeagueIdTradesRouteImport } from './routes/leagues/$leagueId/trades'
import { Route as LeaguesLeagueIdWaiversRouteImport } from './routes/leagues/$leagueId/waivers'
import { Route as LeaguesLeagueIdWeeksRouteImport } from './routes/leagues/$leagueId/weeks'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunitiesRoute = CommunitiesRouteImport.update({
  id: '/communities',
  path: '/communities',
  getParentRoute: () => rootRouteImport,
} as any)
const ContentRoute = ContentRouteImport.update({
  id: '/content',
  path: '/content',
  getParentRoute: () => rootRouteImport,
} as any)
const DataOpsRoute = DataOpsRouteImport.update({
  id: '/data-ops',
  path: '/data-ops',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsRoute = MetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PhilanthropyRoute = PhilanthropyRouteImport.update({
  id: '/philanthropy',
  path: '/philanthropy',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaguesIndexRoute = LeaguesIndexRouteImport.update({
  id: '/leagues/',
  path: '/leagues/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaguesLeagueIdRoute = LeaguesLeagueIdRouteImport.update({
  id: '/leagues/$leagueId',
  path: '/leagues/$leagueId',
  getParentRoute: () => rootRouteImport,
} as any)
const SquadsIndexRoute = SquadsIndexRouteImport.update({
  id: '/squads/',
  path: '/squads/',
  getParentRoute: () => rootRouteImport,
} as any)
const SquadsSquadIdRoute = SquadsSquadIdRouteImport.update({
  id: '/squads/$squadId',
  path: '/squads/$squadId',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const LeaguesLeagueIdIndexRoute = LeaguesLeagueIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdActivityRoute = LeaguesLeagueIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdDraftRoute = LeaguesLeagueIdDraftRouteImport.update({
  id: '/draft',
  path: '/draft',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdMembersRoute = LeaguesLeagueIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdPhilanthropyRoute =
  LeaguesLeagueIdPhilanthropyRouteImport.update({
    id: '/philanthropy',
    path: '/philanthropy',
    getParentRoute: () => LeaguesLeagueIdRoute,
  } as any)
const LeaguesLeagueIdPlayoffsRoute = LeaguesLeagueIdPlayoffsRouteImport.update({
  id: '/playoffs',
  path: '/playoffs',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdRostersRoute = LeaguesLeagueIdRostersRouteImport.update({
  id: '/rosters',
  path: '/rosters',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdTradesRoute = LeaguesLeagueIdTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdWaiversRoute = LeaguesLeagueIdWaiversRouteImport.update({
  id: '/waivers',
  path: '/waivers',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)
const LeaguesLeagueIdWeeksRoute = LeaguesLeagueIdWeeksRouteImport.update({
  id: '/weeks',
  path: '/weeks',
  getParentRoute: () => LeaguesLeagueIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/communities': typeof CommunitiesRoute
  '/content': typeof ContentRoute
  '/data-ops': typeof DataOpsRoute
  '/design-system': typeof DesignSystemRoute
  '/metrics': typeof MetricsRoute
  '/notifications': typeof NotificationsRoute
  '/philanthropy': typeof PhilanthropyRoute
  '/settings': typeof SettingsRoute
  '/leagues/$leagueId': typeof LeaguesLeagueIdRouteWithChildren
  '/squads/$squadId': typeof SquadsSquadIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/leagues/': typeof LeaguesIndexRoute
  '/squads/': typeof SquadsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/leagues/$leagueId/activity': typeof LeaguesLeagueIdActivityRoute
  '/leagues/$leagueId/draft': typeof LeaguesLeagueIdDraftRoute
  '/leagues/$leagueId/members': typeof LeaguesLeagueIdMembersRoute
  '/leagues/$leagueId/philanthropy': typeof LeaguesLeagueIdPhilanthropyRoute
  '/leagues/$leagueId/playoffs': typeof LeaguesLeagueIdPlayoffsRoute
  '/leagues/$leagueId/rosters': typeof LeaguesLeagueIdRostersRoute
  '/leagues/$leagueId/trades': typeof LeaguesLeagueIdTradesRoute
  '/leagues/$leagueId/waivers': typeof LeaguesLeagueIdWaiversRoute
  '/leagues/$leagueId/weeks': typeof LeaguesLeagueIdWeeksRoute
  '/leagues/$leagueId/': typeof LeaguesLeagueIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/communities': typeof CommunitiesRoute
  '/content': typeof ContentRoute
  '/data-ops': typeof DataOpsRoute
  '/design-system': typeof DesignSystemRoute
  '/metrics': typeof MetricsRoute
  '/notifications': typeof NotificationsRoute
  '/philanthropy': typeof PhilanthropyRoute
  '/settings': typeof SettingsRoute
  '/squads/$squadId': typeof SquadsSquadIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/leagues': typeof LeaguesIndexRoute
  '/squads': typeof SquadsIndexRoute
  '/users': typeof UsersIndexRoute
  '/leagues/$leagueId/activity': typeof LeaguesLeagueIdActivityRoute
  '/leagues/$leagueId/draft': typeof LeaguesLeagueIdDraftRoute
  '/leagues/$leagueId/members': typeof LeaguesLeagueIdMembersRoute
  '/leagues/$leagueId/philanthropy': typeof LeaguesLeagueIdPhilanthropyRoute
  '/leagues/$leagueId/playoffs': typeof LeaguesLeagueIdPlayoffsRoute
  '/leagues/$leagueId/rosters': typeof LeaguesLeagueIdRostersRoute
  '/leagues/$leagueId/trades': typeof LeaguesLeagueIdTradesRoute
  '/leagues/$leagueId/waivers': typeof LeaguesLeagueIdWaiversRoute
  '/leagues/$leagueId/weeks': typeof LeaguesLeagueIdWeeksRoute
  '/leagues/$leagueId': typeof LeaguesLeagueIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/communities': typeof CommunitiesRoute
  '/content': typeof ContentRoute
  '/data-ops': typeof DataOpsRoute
  '/design-system': typeof DesignSystemRoute
  '/metrics': typeof MetricsRoute
  '/notifications': typeof NotificationsRoute
  '/philanthropy': typeof PhilanthropyRoute
  '/settings': typeof SettingsRoute
  '/leagues/$leagueId': typeof LeaguesLeagueIdRouteWithChildren
  '/squads/$squadId': typeof SquadsSquadIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/leagues/': typeof LeaguesIndexRoute
  '/squads/': typeof SquadsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/leagues/$leagueId/activity': typeof LeaguesLeagueIdActivityRoute
  '/leagues/$leagueId/draft': typeof LeaguesLeagueIdDraftRoute
  '/leagues/$leagueId/members': typeof LeaguesLeagueIdMembersRoute
  '/leagues/$leagueId/philanthropy': typeof LeaguesLeagueIdPhilanthropyRoute
  '/leagues/$leagueId/playoffs': typeof LeaguesLeagueIdPlayoffsRoute
  '/leagues/$leagueId/rosters': typeof LeaguesLeagueIdRostersRoute
  '/leagues/$leagueId/trades': typeof LeaguesLeagueIdTradesRoute
  '/leagues/$leagueId/waivers': typeof LeaguesLeagueIdWaiversRoute
  '/leagues/$leagueId/weeks': typeof LeaguesLeagueIdWeeksRoute
  '/leagues/$leagueId/': typeof LeaguesLeagueIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/communities'
    | '/content'
    | '/data-ops'
    | '/design-system'
    | '/metrics'
    | '/notifications'
    | '/philanthropy'
    | '/settings'
    | '/leagues/$leagueId'
    | '/squads/$squadId'
    | '/users/$userId'
    | '/leagues/'
    | '/squads/'
    | '/users/'
    | '/leagues/$leagueId/activity'
    | '/leagues/$leagueId/draft'
    | '/leagues/$leagueId/members'
    | '/leagues/$leagueId/philanthropy'
    | '/leagues/$leagueId/playoffs'
    | '/leagues/$leagueId/rosters'
    | '/leagues/$leagueId/trades'
    | '/leagues/$leagueId/waivers'
    | '/leagues/$leagueId/weeks'
    | '/leagues/$leagueId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/communities'
    | '/content'
    | '/data-ops'
    | '/design-system'
    | '/metrics'
    | '/notifications'
    | '/philanthropy'
    | '/settings'
    | '/squads/$squadId'
    | '/users/$userId'
    | '/leagues'
    | '/squads'
    | '/users'
    | '/leagues/$leagueId/activity'
    | '/leagues/$leagueId/draft'
    | '/leagues/$leagueId/members'
    | '/leagues/$leagueId/philanthropy'
    | '/leagues/$leagueId/playoffs'
    | '/leagues/$leagueId/rosters'
    | '/leagues/$leagueId/trades'
    | '/leagues/$leagueId/waivers'
    | '/leagues/$leagueId/weeks'
    | '/leagues/$leagueId'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/communities'
    | '/content'
    | '/data-ops'
    | '/design-system'
    | '/metrics'
    | '/notifications'
    | '/philanthropy'
    | '/settings'
    | '/leagues/$leagueId'
    | '/squads/$squadId'
    | '/users/$userId'
    | '/leagues/'
    | '/squads/'
    | '/users/'
    | '/leagues/$leagueId/activity'
    | '/leagues/$leagueId/draft'
    | '/leagues/$leagueId/members'
    | '/leagues/$leagueId/philanthropy'
    | '/leagues/$leagueId/playoffs'
    | '/leagues/$leagueId/rosters'
    | '/leagues/$leagueId/trades'
    | '/leagues/$leagueId/waivers'
    | '/leagues/$leagueId/weeks'
    | '/leagues/$leagueId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  CommunitiesRoute: typeof CommunitiesRoute
  ContentRoute: typeof ContentRoute
  DataOpsRoute: typeof DataOpsRoute
  DesignSystemRoute: typeof DesignSystemRoute
  MetricsRoute: typeof MetricsRoute
  NotificationsRoute: typeof NotificationsRoute
  PhilanthropyRoute: typeof PhilanthropyRoute
  SettingsRoute: typeof SettingsRoute
  LeaguesLeagueIdRoute: typeof LeaguesLeagueIdRouteWithChildren
  SquadsSquadIdRoute: typeof SquadsSquadIdRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  LeaguesIndexRoute: typeof LeaguesIndexRoute
  SquadsIndexRoute: typeof SquadsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communities': {
      id: '/communities'
      path: '/communities'
      fullPath: '/communities'
      preLoaderRoute: typeof CommunitiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/content': {
      id: '/content'
      path: '/content'
      fullPath: '/content'
      preLoaderRoute: typeof ContentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-ops': {
      id: '/data-ops'
      path: '/data-ops'
      fullPath: '/data-ops'
      preLoaderRoute: typeof DataOpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics': {
      id: '/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/philanthropy': {
      id: '/philanthropy'
      path: '/philanthropy'
      fullPath: '/philanthropy'
      preLoaderRoute: typeof PhilanthropyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leagues/': {
      id: '/leagues/'
      path: '/leagues'
      fullPath: '/leagues/'
      preLoaderRoute: typeof LeaguesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leagues/$leagueId': {
      id: '/leagues/$leagueId'
      path: '/leagues/$leagueId'
      fullPath: '/leagues/$leagueId'
      preLoaderRoute: typeof LeaguesLeagueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/squads/': {
      id: '/squads/'
      path: '/squads'
      fullPath: '/squads/'
      preLoaderRoute: typeof SquadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/squads/$squadId': {
      id: '/squads/$squadId'
      path: '/squads/$squadId'
      fullPath: '/squads/$squadId'
      preLoaderRoute: typeof SquadsSquadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leagues/$leagueId/': {
      id: '/leagues/$leagueId/'
      path: '/'
      fullPath: '/leagues/$leagueId/'
      preLoaderRoute: typeof LeaguesLeagueIdIndexRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/activity': {
      id: '/leagues/$leagueId/activity'
      path: '/activity'
      fullPath: '/leagues/$leagueId/activity'
      preLoaderRoute: typeof LeaguesLeagueIdActivityRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/draft': {
      id: '/leagues/$leagueId/draft'
      path: '/draft'
      fullPath: '/leagues/$leagueId/draft'
      preLoaderRoute: typeof LeaguesLeagueIdDraftRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/members': {
      id: '/leagues/$leagueId/members'
      path: '/members'
      fullPath: '/leagues/$leagueId/members'
      preLoaderRoute: typeof LeaguesLeagueIdMembersRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/philanthropy': {
      id: '/leagues/$leagueId/philanthropy'
      path: '/philanthropy'
      fullPath: '/leagues/$leagueId/philanthropy'
      preLoaderRoute: typeof LeaguesLeagueIdPhilanthropyRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/playoffs': {
      id: '/leagues/$leagueId/playoffs'
      path: '/playoffs'
      fullPath: '/leagues/$leagueId/playoffs'
      preLoaderRoute: typeof LeaguesLeagueIdPlayoffsRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/rosters': {
      id: '/leagues/$leagueId/rosters'
      path: '/rosters'
      fullPath: '/leagues/$leagueId/rosters'
      preLoaderRoute: typeof LeaguesLeagueIdRostersRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/trades': {
      id: '/leagues/$leagueId/trades'
      path: '/trades'
      fullPath: '/leagues/$leagueId/trades'
      preLoaderRoute: typeof LeaguesLeagueIdTradesRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/waivers': {
      id: '/leagues/$leagueId/waivers'
      path: '/waivers'
      fullPath: '/leagues/$leagueId/waivers'
      preLoaderRoute: typeof LeaguesLeagueIdWaiversRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
    '/leagues/$leagueId/weeks': {
      id: '/leagues/$leagueId/weeks'
      path: '/weeks'
      fullPath: '/leagues/$leagueId/weeks'
      preLoaderRoute: typeof LeaguesLeagueIdWeeksRouteImport
      parentRoute: typeof LeaguesLeagueIdRoute
    }
  }
}

interface LeaguesLeagueIdRouteChildren {
  LeaguesLeagueIdActivityRoute: typeof LeaguesLeagueIdActivityRoute
  LeaguesLeagueIdDraftRoute: typeof LeaguesLeagueIdDraftRoute
  LeaguesLeagueIdMembersRoute: typeof LeaguesLeagueIdMembersRoute
  LeaguesLeagueIdPhilanthropyRoute: typeof LeaguesLeagueIdPhilanthropyRoute
  LeaguesLeagueIdPlayoffsRoute: typeof LeaguesLeagueIdPlayoffsRoute
  LeaguesLeagueIdRostersRoute: typeof LeaguesLeagueIdRostersRoute
  LeaguesLeagueIdTradesRoute: typeof LeaguesLeagueIdTradesRoute
  LeaguesLeagueIdWaiversRoute: typeof LeaguesLeagueIdWaiversRoute
  LeaguesLeagueIdWeeksRoute: typeof LeaguesLeagueIdWeeksRoute
  LeaguesLeagueIdIndexRoute: typeof LeaguesLeagueIdIndexRoute
}

const LeaguesLeagueIdRouteChildren: LeaguesLeagueIdRouteChildren = {
  LeaguesLeagueIdActivityRoute: LeaguesLeagueIdActivityRoute,
  LeaguesLeagueIdDraftRoute: LeaguesLeagueIdDraftRoute,
  LeaguesLeagueIdMembersRoute: LeaguesLeagueIdMembersRoute,
  LeaguesLeagueIdPhilanthropyRoute: LeaguesLeagueIdPhilanthropyRoute,
  LeaguesLeagueIdPlayoffsRoute: LeaguesLeagueIdPlayoffsRoute,
  LeaguesLeagueIdRostersRoute: LeaguesLeagueIdRostersRoute,
  LeaguesLeagueIdTradesRoute: LeaguesLeagueIdTradesRoute,
  LeaguesLeagueIdWaiversRoute: LeaguesLeagueIdWaiversRoute,
  LeaguesLeagueIdWeeksRoute: LeaguesLeagueIdWeeksRoute,
  LeaguesLeagueIdIndexRoute: LeaguesLeagueIdIndexRoute,
}

const LeaguesLeagueIdRouteWithChildren = LeaguesLeagueIdRoute._addFileChildren(
  LeaguesLeagueIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  CommunitiesRoute: CommunitiesRoute,
  ContentRoute: ContentRoute,
  DataOpsRoute: DataOpsRoute,
  DesignSystemRoute: DesignSystemRoute,
  MetricsRoute: MetricsRoute,
  NotificationsRoute: NotificationsRoute,
  PhilanthropyRoute: PhilanthropyRoute,
  SettingsRoute: SettingsRoute,
  LeaguesLeagueIdRoute: LeaguesLeagueIdRouteWithChildren,
  SquadsSquadIdRoute: SquadsSquadIdRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  LeaguesIndexRoute: LeaguesIndexRoute,
  SquadsIndexRoute: SquadsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
